import _ from 'lodash';
import ApplicationRecord from './ApplicationRecord';
/**
 * Abstract class for Chronique
 * @return {Class} Class to extends.
 */
export default function(ChildClass, attributes) {
  return class AbstractChroniqueSection extends ApplicationRecord(
    _.merge(attributes, {
      ID: -1,
      _embedded: {},
    })
  ) {};
}



// WEBPACK FOOTER //
// ./src/models/AbstractChroniqueSection.js